// Section11.jsx — iOS App Development Services
import React from 'react';
import { useReveal, useTilt } from '../../componets/useScrollFX';
const iosBanner = '../assets/iOS App Development Services.webp';

const Section11 = () => {
  const [leftRef, leftVisible] = useReveal();
  const [rightRef, rightVisible] = useReveal();
  const tilt = useTilt(8);

  const security = [
    "Secure authentication",
    "Data encryption",
    "Privacy-focused architecture",
    "Compliance-ready solutions",
    "Secure API integrations"
  ];

  return (
    <section id="ios" className="bg-[#fafafa] py-10 md:py-10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-14 items-center">
          {/* Left Content */}
          <div
            ref={leftRef}
            className={`lg:w-5/12 transition-all duration-700 ${
              leftVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'
            }`}
          >
            <span className="text-[#cd2122] text-xs font-semibold uppercase tracking-widest">iOS</span>
            <h2 className="text-[32px] md:text-[38px] font-extrabold text-[#1a1a1a] leading-tight mt-3 mb-7">
              iOS App Development Services
            </h2>
            <p className="text-[#535353] text-[16px] leading-relaxed mb-2">
              Apple users expect premium experiences. We deliver sophisticated iPhone and iPad applications designed to maximize usability, engagement, and long-term success.
            </p>
            <p className="text-[#535353] text-[16px] leading-relaxed mb-9">
              We create high-quality iPhone and iPad applications designed to maximize usability, engagement, and long-term success.
            </p>

            <div className="space-y-7">
              <div>
                <h3 className="font-semibold text-[16px] text-[#1a1a1a] mb-3">Native iOS Development</h3>
                <p className="text-[#535353] text-[16px] leading-relaxed mb-2">
                  Our iOS development capabilities include:
                </p>
                <ul className="text-[16px] text-[#535353] space-y-2">
                  <li>• Custom iPhone applications</li>
                  <li>• iPad applications</li>
                  <li>• Enterprise iOS solutions</li>
                  <li>• Ecommerce applications</li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold text-[16px] text-[#1a1a1a] mb-3">Exceptional User Experience</h3>
                <p className="text-[#535353] text-[16px] leading-relaxed mb-2">
                  Our iOS app development services prioritize:
                </p>
                <ul className="text-[16px] text-[#535353] space-y-2">
                  <li>• Intuitive user interfaces</li>
                  <li>• Fast loading times</li>
                  <li>• Responsive interactions</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Right: tilting glass frame with real banner + floating security badges */}
          <div
            ref={rightRef}
            className={`lg:w-7/12 transition-all duration-700 delay-150 ${
              rightVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'
            }`}
          >
            <div
              ref={tilt.ref}
              onMouseMove={tilt.onMouseMove}
              onMouseLeave={tilt.onMouseLeave}
              style={{ ...tilt.style, transitionProperty: 'transform' }}
              className="relative rounded-[1.8rem] overflow-hidden shadow-2xl border border-white/60"
            >
              <img src={iosBanner} alt="iOS app development services" className="w-full h-[380px] object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
            </div>

            {/* Security badges — floating glass strip below the image */}
            <div className="mt-6 bg-white/80 backdrop-blur-xl border border-white/60 shadow-xl rounded-3xl p-6">
              <h3 className="text-lg font-bold text-[#1a1a1a] mb-2">Secure and Reliable Applications</h3>
              <p className="text-[#535353] text-[16px] leading-relaxed mb-2">
                Security is integrated throughout the development lifecycle.
              </p>
              <p className="text-[#535353] text-[16px] leading-relaxed mb-5">
                We implement:
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-[15px]">
                {security.map((item, i) => (
                  <div key={i} className="flex items-center gap-3 p-2.5 rounded-xl hover:bg-[#cd2122]/5 transition-colors">
                    <span className="w-6 h-6 flex-shrink-0 rounded-full bg-[#cd2122] text-white text-xs flex items-center justify-center">✔</span>
                    <span className="text-[#535353]">{item}</span>
                  </div>
                ))}
              </div>
              <p className="text-[#535353] text-[16px] leading-relaxed mt-5 mb-2">
                Our goal is to create iOS applications that deliver outstanding experiences while protecting user data and business assets.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section11;